import { updatedDiff } from '@helpers/data';

import {
  PAYMENTS_AGGREGATOR_STATE,
  PaymentsDistributionSettingsItems,
} from '@types';

import { PaymentsSetAggregatorStateReducer } from './types';

export const paymentsSetAggregatorStateReducer: PaymentsSetAggregatorStateReducer =
  (state, action) => {
    const { aggregatorId, aggregatorState } = action.payload;

    const isPaymentSystemsStatesSave =
      aggregatorState === PAYMENTS_AGGREGATOR_STATE.ENABLED;

    if (
      !state.paymentsDistributionSettingsProcessedItems ||
      !state.paymentsDistributionSettingsItems
    ) {
      return state;
    }

    let processed: Partial<PaymentsDistributionSettingsItems>;

    if (isPaymentSystemsStatesSave) {
      processed = {
        ...state.paymentsDistributionSettingsProcessedItems,
        [aggregatorId]: {
          ...state.paymentsDistributionSettingsProcessedItems[aggregatorId],
          aggregatorState,
        },
      };
    } else {
      processed = {
        ...state.paymentsDistributionSettingsProcessedItems,
        [aggregatorId]: {
          ...state.paymentsDistributionSettingsProcessedItems[aggregatorId],
          aggregatorState,
          paymentSystems: {
            ...state.paymentsDistributionSettingsItems[aggregatorId],
          },
        },
      };
    }

    const changes = updatedDiff(
      state.paymentsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      paymentsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
